/* =====================================================================
   FindGear — Landing Posture V2
   JS isolé, léger, sans dépendance. Chargé uniquement par la section
   product.fg-landing. Fonctionne en dégradé : sans JS, le <form> natif
   ajoute au panier et redirige vers /cart.
   ===================================================================== */
(function () {
  'use strict';

  var CART_UPDATE_EVENT = 'cart:update'; // = Horizon CartAddEvent.eventName

  function euro(n) { return n; }

  function initRoot(root) {
    if (root.__fgInit) return;
    root.__fgInit = true;

    var dataEl = root.querySelector('[data-fg-data]') || document.querySelector('[data-fg-data]');
    var config = {};
    try { config = JSON.parse(dataEl.textContent); } catch (e) { config = {}; }
    var variants = config.variants || [];
    var cartUrl = config.cartUrl || '/cart';

    var form = root.querySelector('[data-fg-form]');
    var variantInput = root.querySelector('[data-fg-variant-id]');
    var sizeInputs = Array.prototype.slice.call(root.querySelectorAll('[data-fg-size]'));
    var cta = root.querySelector('[data-fg-cta]');
    var ctaText = root.querySelector('[data-fg-cta-text]');
    var addedMsg = root.querySelector('[data-fg-added]');
    var errorMsg = root.querySelector('[data-fg-error]');
    var selectedSizeLabels = Array.prototype.slice.call(root.querySelectorAll('[data-fg-selected-size]'));

    var priceNow = root.querySelector('[data-fg-price-now]');
    var priceWas = root.querySelector('[data-fg-price-was]');
    var priceOff = root.querySelector('[data-fg-price-off]');
    var priceSave = root.querySelector('[data-fg-price-save]');

    var stickyPrice = root.querySelector('[data-fg-sticky-price]');
    var stickySize = root.querySelector('[data-fg-sticky-size]');

    var current = null; // variant object

    function findVariant(id) {
      id = String(id);
      for (var i = 0; i < variants.length; i++) { if (String(variants[i].id) === id) return variants[i]; }
      return null;
    }

    function setPrice(v) {
      if (!v) return;
      if (priceNow) priceNow.textContent = v.price;
      if (priceWas) { priceWas.textContent = v.compareAt || ''; priceWas.style.display = v.compareAt ? '' : 'none'; }
      if (priceOff) { priceOff.textContent = v.off ? ('-' + v.off + '%') : ''; priceOff.style.display = v.off ? '' : 'none'; }
      if (priceSave) { priceSave.textContent = v.save ? config.saveLabel.replace('%s', v.save) : ''; priceSave.style.display = v.save ? '' : 'none'; }
      if (stickyPrice) stickyPrice.textContent = v.price;
    }

    function setCtaAdd(v) {
      if (ctaText) ctaText.textContent = config.ctaAdd + ' — ' + v.price;
      cta.setAttribute('data-state', 'add');
    }
    function setCtaChoose() {
      if (ctaText) ctaText.textContent = config.ctaChoose;
      cta.setAttribute('data-state', 'choose');
    }

    function selectVariant(v, fromUser) {
      current = v;
      if (variantInput) variantInput.value = v.id;
      setPrice(v);
      setCtaAdd(v);
      selectedSizeLabels.forEach(function (el) { el.textContent = v.sizeLabel; });
      if (stickySize) stickySize.textContent = config.sizeWord + ' ' + v.sizeLabel;
      // état visuel des boutons
      sizeInputs.forEach(function (inp) {
        var lbl = inp.closest('.fg-size');
        if (lbl) lbl.classList.toggle('is-selected', String(inp.value) === String(v.id));
      });
      if (errorMsg) errorMsg.classList.remove('is-visible');
      // média associé
      if (fromUser && v.mediaId) scrollGalleryToMedia(v.mediaId);
    }

    sizeInputs.forEach(function (inp) {
      var v = findVariant(inp.value);
      var lbl = inp.closest('.fg-size');
      if (v && !v.available && lbl) { lbl.classList.add('is-soldout'); inp.disabled = true; }
      inp.addEventListener('change', function () {
        var vv = findVariant(inp.value);
        if (vv && vv.available) selectVariant(vv, true);
      });
    });

    // Etat initial : aucune taille -> CTA "Choisir ma taille"
    setCtaChoose();

    /* ---------- Galerie ---------- */
    var track = root.querySelector('[data-fg-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-fg-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-fg-dot]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-fg-thumb]'));

    function setActiveIndex(idx) {
      dots.forEach(function (d, i) { d.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
      thumbs.forEach(function (t, i) { t.setAttribute('aria-current', i === idx ? 'true' : 'false'); });
    }
    function scrollGalleryToIndex(idx) {
      if (!track || !slides[idx]) return;
      track.scrollTo({ left: slides[idx].offsetLeft, behavior: 'smooth' });
    }
    function scrollGalleryToMedia(mediaId) {
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].getAttribute('data-media-id')) === String(mediaId)) { scrollGalleryToIndex(i); return; }
      }
    }
    if (track) {
      var raf;
      track.addEventListener('scroll', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var idx = Math.round(track.scrollLeft / track.clientWidth);
          idx = Math.max(0, Math.min(slides.length - 1, idx));
          setActiveIndex(idx);
          // pause videos hors écran
          slides.forEach(function (s, i) {
            var vid = s.querySelector('video');
            if (vid && i !== idx && !vid.paused) vid.pause();
          });
        });
      }, { passive: true });
    }
    dots.forEach(function (d, i) { d.addEventListener('click', function () { scrollGalleryToIndex(i); }); });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { scrollGalleryToIndex(i); }); });
    setActiveIndex(0);

    /* ---------- Ajout au panier ---------- */
    function getCartSectionIds() {
      var ids = {};
      var sel = ['cart-drawer-component', 'cart-icon-component', '.cart-bubble', '[id^="shopify-section-"] cart-drawer-component'];
      document.querySelectorAll('cart-drawer-component, cart-icon-component, cart-items-component').forEach(function (el) {
        var sec = el.closest('[id^="shopify-section-"]');
        if (sec) ids[sec.id.replace('shopify-section-', '')] = true;
      });
      return Object.keys(ids);
    }

    function applySections(sections) {
      if (!sections) return;
      Object.keys(sections).forEach(function (id) {
        var el = document.getElementById('shopify-section-' + id);
        if (el && typeof sections[id] === 'string') {
          try { el.innerHTML = sections[id]; } catch (e) {}
        }
      });
    }

    function openCartDrawer(cart, sections) {
      var drawer = document.querySelector('cart-drawer-component');
      if (!drawer) return false;
      var evt;
      try {
        evt = new CustomEvent(CART_UPDATE_EVENT, {
          bubbles: true,
          detail: { resource: cart, sourceId: 'fg-landing', data: { source: 'fg-landing', itemCount: cart ? cart.item_count : undefined, sections: sections } }
        });
      } catch (e) { evt = null; }
      if (evt) document.dispatchEvent(evt);
      // Le custom element peut être remplacé par applySections : on ré-essaie
      // jusqu'à ce que sa méthode open() soit disponible (upgrade terminé).
      function tryOpen(attempt) {
        var d = document.querySelector('cart-drawer-component');
        var dlg = d && d.querySelector('dialog');
        if (dlg) {
          // Laisse le thème gérer scroll-lock/animations, puis force l'ouverture si besoin.
          try { if (typeof d.open === 'function') d.open(); } catch (e) {}
          if (!dlg.open) { try { dlg.showModal(); } catch (e) {} }
          if (dlg.open) return;
        }
        if (attempt < 12) setTimeout(function () { tryOpen(attempt + 1); }, 60);
      }
      tryOpen(0);
      return true;
    }

    var submitting = false;
    function doAdd() {
      if (submitting) return;
      if (!current) { // pas de taille -> aller au sélecteur
        setCtaChoose();
        if (errorMsg) { errorMsg.textContent = config.chooseError; errorMsg.classList.add('is-visible'); }
        var sel = root.querySelector('[data-fg-selector]');
        if (sel && sel.scrollIntoView) sel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var firstAvail = sizeInputs.filter(function (i) { return !i.disabled; })[0];
        if (firstAvail) firstAvail.focus();
        return;
      }
      submitting = true;
      cta.classList.add('is-loading');
      cta.disabled = true;
      if (addedMsg) addedMsg.classList.remove('is-visible');
      if (errorMsg) errorMsg.classList.remove('is-visible');

      var sectionIds = getCartSectionIds();
      var body = { items: [{ id: current.id, quantity: 1 }], sections_url: window.location.pathname };
      if (sectionIds.length) body.sections = sectionIds.join(',');

      fetch(cartUrl.replace(/\/cart.*/, '') + '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
        body: JSON.stringify(body)
      }).then(function (res) {
        return res.json().then(function (json) { return { ok: res.ok, json: json }; });
      }).then(function (r) {
        if (!r.ok) {
          var msg = (r.json && (r.json.description || r.json.message)) || config.genericError;
          if (errorMsg) { errorMsg.textContent = msg; errorMsg.classList.add('is-visible'); }
          return;
        }
        var sections = r.json && r.json.sections;
        applySections(sections);
        if (addedMsg) addedMsg.classList.add('is-visible');
        // Récupérer l'état complet du panier pour l'event + ouvrir le drawer
        fetch(cartUrl.replace(/\/cart.*/, '') + '/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (c) { return c.json(); })
          .then(function (cart) {
            var opened = openCartDrawer(cart, sections);
            if (!opened) { window.location.href = cartUrl; }
          })
          .catch(function () {
            var opened = openCartDrawer(null, sections);
            if (!opened) window.location.href = cartUrl;
          });
      }).catch(function () {
        // Réseau KO -> soumission native en secours
        if (form) form.submit();
      }).finally(function () {
        submitting = false;
        cta.classList.remove('is-loading');
        cta.disabled = false;
      });
    }

    if (form) {
      form.addEventListener('submit', function (e) {
        // Intercepte uniquement si fetch dispo
        if (window.fetch) { e.preventDefault(); doAdd(); }
      });
    }

    /* ---------- Barre sticky ---------- */
    var sticky = root.querySelector('[data-fg-sticky]');
    var sentinel = root.querySelector('[data-fg-sentinel]');
    var stickyCta = root.querySelector('[data-fg-sticky-cta]');
    if (sticky && sentinel && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0);
        });
      }, { threshold: 0, rootMargin: '0px 0px -60% 0px' });
      io.observe(sentinel);
    }
    if (stickyCta) {
      stickyCta.addEventListener('click', function () {
        if (!current) {
          var sel = root.querySelector('[data-fg-selector]');
          if (sel && sel.scrollIntoView) sel.scrollIntoView({ behavior: 'smooth', block: 'center' });
          var firstAvail = sizeInputs.filter(function (i) { return !i.disabled; })[0];
          if (firstAvail) firstAvail.focus();
        } else {
          doAdd();
        }
      });
    }

    /* ---------- CTA "Choisir ma taille" (état choose) : scroll ---------- */
    // géré par doAdd() quand current == null

    /* ---------- Drawer guide des tailles ---------- */
    var guide = root.querySelector('[data-fg-guide]');
    var openers = Array.prototype.slice.call(root.querySelectorAll('[data-fg-guide-open]'));
    var lastFocus = null;
    function openGuide() {
      if (!guide) return;
      lastFocus = document.activeElement;
      guide.hidden = false;
      void guide.offsetWidth; // reflow -> la transition joue à l'ajout de la classe
      guide.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      var closeBtn = guide.querySelector('[data-fg-guide-close]');
      if (closeBtn) closeBtn.focus();
      document.addEventListener('keydown', onKey);
    }
    function closeGuide() {
      if (!guide) return;
      guide.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      setTimeout(function () { guide.hidden = true; }, 280);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function onKey(e) { if (e.key === 'Escape') closeGuide(); }
    openers.forEach(function (o) { o.addEventListener('click', openGuide); });
    if (guide) {
      guide.querySelectorAll('[data-fg-guide-close]').forEach(function (b) { b.addEventListener('click', closeGuide); });
    }
  }

  function boot() {
    document.querySelectorAll('[data-fg-root]').forEach(initRoot);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
  // Support éditeur de thème Shopify
  document.addEventListener('shopify:section:load', boot);
})();
